export const exportAlarmsToCSV = (alarms, careTeam, accountId = '') => {
    // Helper function to get resolver name
    const getResolverName = (resolverId) => {
        if (resolverId === "system") {
            return "System";
        }

        // Get resolver name from care team
        const careTeamMember = careTeam.find((staff) => staff.id === resolverId);
        if (careTeamMember) {
            return `${careTeamMember.firstName} ${careTeamMember.lastName}`;
        }
        return "Unknown";
    };

    // Helper function to escape CSV fields
    const escapeCSVField = (field) => {
        if (field === null || field === undefined) {
            return '';
        }
        const stringField = String(field);
        // If field contains comma, quotes, or newlines, wrap in quotes and escape quotes
        if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
            return `"${stringField.replace(/"/g, '""')}"`;
        }
        return stringField;
    };

    // CSV Headers
    const headers = [
        'AccountID',
        'Metric',
        'Category',
        'Priority',
        'Created Date',
        'Resolved Date',
        'Resolution',
        'Notes'
    ];

    // Convert alarms to CSV rows
    const rows = alarms.map(alarm => {
        const resolverName = getResolverName(alarm.alert_resolverId);
        const createdDate = alarm.createdDate ? new Date(alarm.createdDate).toISOString() : '';
        const resolvedDate = alarm.alert_resolvedTimestamp ? new Date(alarm.alert_resolvedTimestamp).toISOString() : '';
        const resolvedBy = alarm.alert_resolverId === "system" ? "System" : resolverName;

        return [
            escapeCSVField(accountId),
            escapeCSVField(alarm.alert_display_name ?? alarm.alert_name),
            escapeCSVField(alarm.alert_category ?? ''),
            escapeCSVField(alarm.alert_priority ?? ''),
            escapeCSVField(createdDate),
            escapeCSVField(resolvedDate),
            escapeCSVField(resolvedBy),
            escapeCSVField(alarm.alert_description ?? 'No description')
        ];
    });

    // Combine headers and rows
    const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
    ].join('\n');

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    const filename = `alarm_history_${accountId}_${Date.now()}.csv`;
    
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.click();
};

